import { z, isoZ } from 'my-zod'

export type DiffAtom = string | number | boolean | null

const zAtom: z.ZodSchema<DiffAtom> = z.union([z.string(), z.number(), z.boolean(), z.null()])

export const changeLogDiffLine = z.object({
  path: z.string(),
  old: zAtom,
  new: zAtom
})
export type changeLogDiffLine = z.infer<typeof changeLogDiffLine>

export const changeLogEntryModel = z.object({
  id: z.number(),
  topic: z.string(),
  profileId: z.number(),
  operation: z.string(),
  diff: changeLogDiffLine.array(),
  current: z.any(),
  createdDate: isoZ.instant()
})

export type changeLogEntryModel = z.infer<typeof changeLogEntryModel>
